// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "es6-string-polyfills";
import "babel-polyfill";
import 'font-awesome/css/font-awesome.css';
import 'normalize.css/normalize.css';
import 'vue-transition-css/dist/css/vue-transition.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';


import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueAnalytics from 'vue-analytics'
import VueAuth from '@websanova/vue-auth';
// import VueAuthAuth from '@websanova/vue-auth/drivers/auth/bearer';
import VueAuthHttp from '@websanova/vue-auth/drivers/http/axios.1.x';
import VueAuthRouter from '@websanova/vue-auth/drivers/router/vue-router.2.x';
import VueRouter from 'vue-router';
import Chartkick from 'chartkick';
import VueChartkick from 'vue-chartkick';
import AsyncComputed from 'vue-async-computed';
import Chart from 'chart.js';
import App from './App';
// import auth from './auth';
import VueAuthAuth from './bearer';
import router from './router';
import store from './store';
import env from './environment.config';


axios.defaults.baseURL = env.baseUrl;

if (!env.baseUrl.includes('tannin-alert')) {
  Vue.use(VueAnalytics, {
    id: 'UA-388081-45',
    router,
  });
}

Vue.use(VueRouter);
Vue.use(VueAxios, axios);

Vue.use(VueChartkick, { Chartkick });
Vue.use(AsyncComputed);

Vue.config.productionTip = false;


Vue.router = router;

Vue.use(VueAuth, {
  auth: VueAuthAuth,
  http: VueAuthHttp,
  router: VueAuthRouter,
  token: [
    { request: 'Authorization', response: 'Authorization', authType: 'bearer', foundIn: 'data' },
    { request: 'token', response: 'token', authType: 'bearer', foundIn: 'response' },
  ],
  refreshData: { url: 'auth/refreshX', method: 'GET', enabled: false, interval: 30 },
  parseUserData(dataIn) {
    const data = dataIn;
    data.roles = [data.role];
    return data;
  },
});

App.router = Vue.router;
App.store = store;
new Vue(App).$mount('#app');

/* eslint-disable no-new */
/*
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
});

*/



// WEBPACK FOOTER //
// ./src/main.js